import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export type SymptomAdviceResult =
  | {
      ok: true;
      advice: {
        service: string;
        urgency: "Today" | "This Week" | "No Rush";
        explanation: string;
        safetyWarning: string | null;
        enquiry: string;
      };
    }
  | { ok: false; error: string };

export const suggestServiceForSymptoms = createServerFn({ method: "POST" })
  .inputValidator((data) =>
    z
      .object({
        symptoms: z.string().trim().min(10).max(1200),
        vehicle: z.string().trim().max(120).optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }): Promise<SymptomAdviceResult> => {
    const { adviseOnSymptoms, AdvisorError } = await import("./symptom-advisor.server");
    try {
      return { ok: true, advice: await adviseOnSymptoms(data) };
    } catch (e) {
      if (e instanceof AdvisorError) return { ok: false, error: e.message };
      return { ok: false, error: "Something went wrong. Please try again or call us." };
    }
  });
